<div class="form" *appContactsAppContext>
  <div class="form-date">{{ contact?.createdAt | dateFormat: 'date' }}</div>

  <h2 class="form-title">
    <app-icon class="form-heading-title-icon" name="contacts" [style.color]="contact?.color" />
    {{ contact?.title }}
  </h2>

  @if (contact) {
    <app-shared-tags class="form-tags" [stitchItem]="contact" [stateKey]="StateKey.tagsList" />

    <app-shared-knots class="form-knots" [stitchItem]="contact" [stateKey]="StateKey.knotsList" />
  }

  <app-shared-signup-cta />

  <div class="form-details">
    <div class="form-details-row">
      <div class="form-details-row-title">Job Title</div>
      <div class="form-details-row-input">{{ contact?.jobTitle }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Company</div>
      <div class="form-details-row-input">{{ contact?.company }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Vip contact</div>
      <div class="form-details-row-input">{{ contact?.vip }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Country</div>
      <div class="form-details-row-input">{{ contact?.country }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Phone Number</div>
      <div class="form-details-row-input">
        @for (phone of contact?.phones; track phone.value) {
          <p>
            {{ phone.category }}
            {{ phone.value }}
          </p>
        }
      </div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Email</div>
      <div class="form-details-row-input">
        @for (email of contact?.emails; track email.value) {
          <p>
            {{ email.category }}
            {{ email.value }}
          </p>
        }
      </div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Birthday</div>
      <div class="form-details-row-input">{{ contact?.birthDate }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Address</div>
      <div class="form-details-row-input">{{ contact?.address }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Website</div>
      <div class="form-details-row-input">{{ contact?.website }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Group</div>
      <div class="form-details-row-input">{{ contact?.groupId }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Description</div>
      <stch-item-description class="form-details-row-input" stchHighlightText [html]="contact?.description" />
    </div>
  </div>
</div>
